(() => {
  'use strict';


  const DATA_ID =
    'SctGlobalRankingData';


  /*
   * Dawnの商品カードだけ対象
   */
  const CARD_SELECTOR =
    '.card-wrapper.product-card-wrapper';


  /*
   * ここは常にグローバルランキングを出さない
   */
  const ALWAYS_SKIP_SELECTOR = [
    '[data-sct-module="trending_now"]',
    '[data-sct-module="category_best_seller"]',
    '.collection-sales-ranking',
  ].join(',');


  let rankingMap =
    new Map();



  /* =========================================================
     READ DATA
     ========================================================= */

  function readRankingData() {

    const node =
      document.getElementById(
        DATA_ID
      );


    if (!node) {
      return;
    }


    try {

      const data =
        JSON.parse(
          node.textContent || '[]'
        );


      if (
        !Array.isArray(
          data
        )
      ) {
        return;
      }


      rankingMap =
        new Map(
          data
            .filter(
              item =>
                item &&
                item.handle &&
                item.rank
            )
            .map(
              item => [
                String(
                  item.handle
                ),
                Number(
                  item.rank
                ),
              ]
            )
        );

    } catch (error) {

      console.warn(
        '[SCULTURE Ranking] Failed to read ranking data.',
        error
      );

    }

  }



  /* =========================================================
     PRODUCT HANDLE
     ========================================================= */

  function getProductHandle(
    card
  ) {

    const link =
      card.querySelector(
        'a[href*="/products/"]'
      );


    if (!link) {
      return null;
    }


    try {

      const url =
        new URL(
          link.href,
          window.location.origin
        );


      const match =
        url.pathname.match(
          /\/products\/([^/?#]+)/
        );


      return match
        ? decodeURIComponent(
            match[1]
          )
        : null;

    } catch (_error) {

      return null;

    }

  }



  /* =========================================================
     SHOP BY STYLE 判定

     Rankingタブだけグローバルランキングを表示。
     その他のStyleタブでは表示しない。
     ========================================================= */

  function shouldSkipCard(
    card
  ) {

    /*
     * TRENDING NOWなど
     */
    if (
      card.closest(
        ALWAYS_SKIP_SELECTOR
      )
    ) {
      return true;
    }


    /*
     * Shop by Style内かどうか
     */
    const shopByStyle =
      card.closest(
        '[data-sct-module="shop_by_style"]'
      );


    if (!shopByStyle) {

      /*
       * Shop by Style以外の通常商品カードは
       * グローバルランキング対象
       */
      return false;

    }


    /*
     * Shop by Styleの場合、
     * 現在の商品が属しているパネルを取得
     */
    const panel =
      card.closest(
        '.js-panel'
      );


    if (!panel) {
      return true;
    }


    const tabName =
      (
        panel.dataset
          .sctTabName ||
        ''
      )
        .trim()
        .toLowerCase();


    const collectionHandle =
      (
        panel.dataset
          .sctCollectionHandle ||
        ''
      )
        .trim()
        .toLowerCase();


    /*
     * Rankingタブ
     *
     * タブ名がRanking
     * または
     * collectionがbest-seller
     *
     * のどちらかなら表示
     */
    const isRankingTab =
      tabName ===
        'ranking' ||
      collectionHandle ===
        'best-seller';


    return !isRankingTab;

  }



  /* =========================================================
     CREATE BADGE
     ========================================================= */

  function createBadge(
    rank
  ) {

    const badge =
      document.createElement(
        'div'
      );


    badge.className =
      'sculture-ranking-badge';


    if (rank === 1) {

      badge.classList.add(
        'sculture-ranking-badge--gold'
      );

    } else if (
      rank === 2
    ) {

      badge.classList.add(
        'sculture-ranking-badge--silver'
      );

    } else if (
      rank === 3
    ) {

      badge.classList.add(
        'sculture-ranking-badge--bronze'
      );

    }


    badge.setAttribute(
      'aria-label',
      `Ranking No.${rank}`
    );


    const label =
      document.createElement(
        'span'
      );


    label.className =
      'sculture-ranking-badge__label';


    label.textContent =
      'RANK';


    const number =
      document.createElement(
        'span'
      );


    number.className =
      'sculture-ranking-badge__number';


    number.textContent =
      String(
        rank
      );


    badge.append(
      label,
      number
    );


    return badge;

  }



  /* =========================================================
     DECORATE CARD
     ========================================================= */

  function decorateCard(
    card
  ) {

    if (
      !(card instanceof Element)
    ) {
      return;
    }


    if (
      card.dataset
        .sctRankingProcessed ===
        'true'
    ) {
      return;
    }


    card.dataset
      .sctRankingProcessed =
        'true';


    /*
     * 表示対象か判定
     */
    if (
      shouldSkipCard(
        card
      )
    ) {
      return;
    }


    const handle =
      getProductHandle(
        card
      );


    if (!handle) {
      return;
    }


    const rank =
      rankingMap.get(
        handle
      );


    if (!rank) {
      return;
    }


    /*
     * 二重表示防止
     */
    if (
      card.querySelector(
        '.sculture-ranking-badge'
      )
    ) {
      return;
    }


    /*
     * Dawnの.card__mediaには触らない。
     *
     * .card__innerへバッジだけ追加する。
     */
    const target =
      card.querySelector(
        '.card__inner'
      );


    if (!target) {
      return;
    }


    target.appendChild(
      createBadge(
        rank
      )
    );

  }



  /* =========================================================
     SCAN
     ========================================================= */

  function scan(
    root = document
  ) {

    if (
      root instanceof Element &&
      root.matches(
        CARD_SELECTOR
      )
    ) {

      decorateCard(
        root
      );

    }


    root
      .querySelectorAll?.(
        CARD_SELECTOR
      )
      .forEach(
        decorateCard
      );

  }



  /* =========================================================
     RESET + RESCAN

     Shop by Styleのタブ切替などで
     再判定できるようにする。
     ========================================================= */

  function resetAndScan(
    root = document
  ) {

    root
      .querySelectorAll?.(
        CARD_SELECTOR
      )
      .forEach(
        card => {

          delete card.dataset
            .sctRankingProcessed;


          card
            .querySelectorAll(
              '.sculture-ranking-badge'
            )
            .forEach(
              badge =>
                badge.remove()
            );

        }
      );


    scan(
      root
    );

  }



  /* =========================================================
     SHOP BY STYLE TAB CHANGE
     ========================================================= */

  function watchShopByStyleTabs() {

    document.addEventListener(
      'click',
      event => {

        const target =
          event.target instanceof
            Element
            ? event.target
            : null;


        if (!target) {
          return;
        }


        const tab =
          target.closest(
            '[data-sct-module="shop_by_style"] .js-tab'
          );


        if (!tab) {
          return;
        }


        const module =
          tab.closest(
            '[data-sct-module="shop_by_style"]'
          );


        if (!module) {
          return;
        }


        /*
         * collection-tab側のタブ切替処理後に
         * ランキング表示を再判定
         */
        window.setTimeout(
          () => {

            resetAndScan(
              module
            );

          },
          0
        );

      },
      true
    );

  }



  /* =========================================================
     DYNAMIC PRODUCTS
     Boost / Filter / AJAX対応
     ========================================================= */

  function watchDynamicCards() {

    if (
      !(
        'MutationObserver'
        in window
      ) ||
      !document.body
    ) {
      return;
    }


    const observer =
      new MutationObserver(
        mutations => {

          mutations.forEach(
            mutation => {

              mutation
                .addedNodes
                .forEach(
                  node => {

                    if (
                      node instanceof
                      Element
                    ) {

                      scan(
                        node
                      );

                    }

                  }
                );

            }
          );

        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
      }
    );

  }



  /* =========================================================
     INIT
     ========================================================= */

  function init() {

    readRankingData();


    if (
      rankingMap.size === 0
    ) {
      return;
    }


    scan(
      document
    );


    watchDynamicCards();


    watchShopByStyleTabs();


    /*
     * Shopify Theme Editor
     */
    document.addEventListener(
      'shopify:section:load',
      event => {

        resetAndScan(
          event.target
        );

      }
    );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true,
      }
    );

  } else {

    init();

  }

})();